import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getCultPosts, getStrapiConfigured } from '../utils/strapi';

const Cult = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let alive = true;

    const load = async () => {
      try {
        setError('');
        setLoading(true);

        if (!getStrapiConfigured()) {
          throw new Error('Cult is not configured. Set VITE_STRAPI_URL.');
        }

        const data = await getCultPosts({ pageSize: 24 });
        if (!alive) return;
        setPosts(data);
      } catch (e) {
        if (!alive) return;
        setError(e instanceof Error ? e.message : 'Failed to load');
      } finally {
        if (!alive) return;
        setLoading(false);
      }
    };

    load();

    return () => {
      alive = false;
    };
  }, []);

  return (
    <div className="cult-page">
      <section className="section cult-hero">
        <div className="wrapper grid-display">
          <div className="row">
            <div className="col-3">
              <span className="mono">Cult</span>
            </div>
            <div className="col-2" />
            <div className="col-7">
              <div className="large light">Local stories, features, and good trouble.</div>
              <p className="mono cult-kicker">
                A feed of blog posts, articles, and features — curated by Heretic.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="section cult-feed">
        <div className="wrapper grid-display">
          {loading ? (
            <div className="row">
              <div className="col-12 mono">Loading…</div>
            </div>
          ) : null}

          {error ? (
            <div className="row">
              <div className="col-12 mono">{error}</div>
            </div>
          ) : null}

          {!loading && !error ? (
            <div className="row">
              <div className="col-12">
                <div className="cult-grid">
                  {posts.map((post) => (
                    <Link
                      key={post.id}
                      to={`/cult/${post.slug}`}
                      className="cult-card"
                    >
                      {post.coverUrl ? (
                        <div className="cult-card__media">
                          <img src={post.coverUrl} alt={post.title} />
                        </div>
                      ) : null}

                      <div className="cult-card__body">
                        <div className="mono cult-card__title">{post.title}</div>
                        {post.excerpt ? (
                          <div className="mono cult-card__excerpt">{post.excerpt}</div>
                        ) : null}
                        {post.publishedAt ? (
                          <div className="mono cult-card__meta">
                            {new Date(post.publishedAt).toLocaleDateString(undefined, {
                              year: 'numeric',
                              month: 'short',
                              day: 'numeric',
                            })}
                          </div>
                        ) : null}
                      </div>
                    </Link>
                  ))}
                </div>
              </div>
            </div>
          ) : null}
        </div>
      </section>
    </div>
  );
};

export default Cult;
